function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 16"
}, props), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M22 15.75h0c.95 0 1.74-.77 1.75-1.75V2a1.79 1.79 0 00-.52-1.24A1.72 1.72 0 0022 .25H2a1.72 1.72 0 00-1.23.5C.44 1.1.25 1.55.25 2v12c0 .46.19.91.52 1.24.33.33.77.51 1.23.51h20zm0 .5h0z",
  strokeOpacity: ".2",
  strokeWidth: ".5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10 2.05v-.01h4v.01a6 6 0 010 11.97v.02h-4v-.02a6 6 0 010-11.97z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.6 11.43a3.6 3.6 0 000-6.79v6.79zM9.2 4.64a3.6 3.6 0 000 6.79V4.64zm1.2 8.6a5.2 5.2 0 110-10.4 5.2 5.2 0 010 10.4z"
}))));